import React from "react"

import Filters from "features/records/components/RecordFilters"
import WithObject from "data/wrappers/WithObject"
import withContext from "../../../withContext"

export default withContext(({ context, ...props }) => (
    <WithObject objectId={context.block.config.attributes.objectId}>
        {({ object }) => <Filters object={object} {...props} />}
    </WithObject>
))



// WEBPACK FOOTER //
// ./src/features/editor/attributes/items/form/objectFilters.js